import { useState } from "react";
import styles from '../../css/payments/explore-pricing.module.css'
import { RewardsBGColors } from "../../../Colors";
import DownArrow from '../../../images/down-arrow-circle.svg';
import { SelectPlanButton } from "./SelectPlanButton";

const MONTHLY_PRICE_ID = process.env.REACT_APP_STRIPE_MONTHLY_SUBSCRIPTION;
const PRICE_AMOUNT = 16;

export const MonthlyPriceTileDesktop = ({ timeOfDay }) => {
    return (
        <div className={styles.pricesContainerOuter} style={{ background: RewardsBGColors[timeOfDay], maxWidth: "18rem" }}>
            <div className={styles.pricesContainerInner}>
                <div className={styles.planHeader}>
                    <p className={styles.planTitle}>INTRO</p>
                </div>
                <div className={styles.priceSection}>
                    <span className={styles.price}>${PRICE_AMOUNT}</span>
                    <span className={styles.billingCycle}>/ month</span>
                </div>
                <hr className={styles.divider} />
                <ul className={styles.featuresList}>
                    <li>35 flows a month</li>
                    <li style={{ whiteSpace: "nowrap" }}>4 weeks of insights</li>
                    <li>1 monthly work big picture</li>
                </ul>
                <SelectPlanButton
                    extraStyles={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}
                    buttonText={'SELECT PLAN'}
                    stripePriceId={MONTHLY_PRICE_ID}
                />
            </div>
        </div>
    )
}

export const MonthlyPriceTileMobile = ({ timeOfDay }) => {
    const [showFeatures, setShowFeatures] = useState(false);

    const borderColor = timeOfDay !== 'night' ? RewardsBGColors[timeOfDay] : "linear-gradient(to bottom, rgb(87, 1, 83), rgb(11, 148, 161))";

    return (
        <div
            className={styles.pricesContainerMobile}
            style={{ background: borderColor }}
        >
            <div className={styles.pricesContainerInnerMobile}>
                <div
                    className={styles.headingSection}
                    onClick={() => setShowFeatures(!showFeatures)}
                >
                    <div className={styles.planDescriptionSectionMobile}>
                        <h2 className={styles.planTitleMobile}>INTRO</h2>
                        <div className={styles.seeMoreTextSection}>
                            <p className={styles.seeMoreText}>Limited flows</p>
                            <img
                                src={DownArrow}
                                width={16}
                                // rotate image 180 degrees when dropdown is open
                                style={{ transform: showFeatures ? "rotate(180deg)" : "none", transition: "transform 0.5s" }}
                            />
                        </div>
                    </div>
                    <div className={styles.pricingSectionMobile}>
                        <h3 className={styles.priceMobile}>${PRICE_AMOUNT}</h3>
                        <hr className={styles.priceDividerMobile} />
                        <p className={styles.billingCycleMobile}>month</p>
                    </div>
                </div>
                <div
                    className={
                        showFeatures
                            ? `${styles.dropdownOpen}`
                            : `${styles.dropdownClosed}`
                    }
                >
                    <hr className={styles.divider} />
                    <ul className={`${styles.featuresList} ${styles.featuresListMobile}`}>
                        <li>Up to 35 flows a month</li>
                        <li>4 weeks of insights</li>
                        <li>1 monthly work big picture</li>
                    </ul>
                    <SelectPlanButton
                        extraStyles={{ marginTop: 0, fontSize: "0.8rem" }}
                        buttonText={'SELECT PLAN'}
                        stripePriceId={MONTHLY_PRICE_ID}
                    />
                </div>
            </div>
        </div>
    )
}